module.exports = __webpack_public_path__ + "static/media/HuaweiLogo.8e70e905.png";